// button scroll top
const button = $('.def-goToTop');

if (button.length > 0) {
  window.addEventListener('scroll', function (e) {
    const position = window.scrollY;

    if (position > 50) {
      button.addClass('def-goToTop_active');
    } else {
      button.removeClass('def-goToTop_active');
    }
  });
  button.on('click', function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
  });
}
